import { AnonymousStudentErrorType } from "../../../../anonymous-student-interfaces/enumerations/error-type";
import { StudentAPIBaseError } from "./student-api-base-error";

export class StudentAPIValidationError extends StudentAPIBaseError {
	constructor(message: string = AnonymousStudentErrorType.VALIDATION_ERROR) {
		super(message);
		this.name = AnonymousStudentErrorType.VALIDATION_ERROR;
	}
}
